import { useReadOnly } from 'utils/lifecycle'
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { get } from 'lodash';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import { ConfirmationDialog } from 'components';
import api from 'utils/api';
import * as businessActions from 'modules/Business/actions';
import * as userActions from 'modules/User/actions';

const PaymentCard = ({ card }) => {
  const readOnly = useReadOnly()
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [confirm, setConfirm] = useState(false);
  const businessId = useSelector(state => get(state, 'business.businessId'));

  const handleDelete = useCallback(() => {
    api
      .delete(`/stripe/customer/card/${card.id}`)
      .then(() => {
        setConfirm(false);
        enqueueSnackbar('Card deleted', { variant: 'success' });
        dispatch(businessActions.fetchBusiness(businessId, true));
        dispatch(userActions.fetchUser());
      })
      .catch(() => {
        enqueueSnackbar('Cannot delete card', { variant: 'error' });
      });
  }, [businessId, card.id, dispatch, enqueueSnackbar]);

  return (
    <>
      <Card sx={{ borderRadius: 2, boxShadow: 3, p: 2 }}>
        <CardContent>
          <Typography gutterBottom variant="h6">
            {card.brand} **** **** **** {card.last4}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Expires on {card.expMonth}/{card.expYear}
          </Typography>
        </CardContent>
        <CardActions>
          <Button disabled={readOnly}
            color="error"
            onClick={() => setConfirm(true)}
          >
            Delete card
          </Button>
        </CardActions>
      </Card>
      {confirm && !readOnly && (
        <ConfirmationDialog
          isOpen
          title="Delete card"
          body="Are you sure you want to delete your card?"
          successButtonLabel="Delete"
          onCancel={() => setConfirm(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
};

export default PaymentCard;
